"use client";
import * as React from "react";
import { FC } from "react";
import FontAwesomeIcon from "./reactFontAwesome";
import FaIcons from "./faIcons";
import type { FontAwesomeIconProps } from "./reactFontAwesome";
import { IconProp, config } from "@fortawesome/fontawesome-svg-core";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { toIconProp } from "./faIcons";

// Adding this to prevent fontawesome to inject style tag in header,
// want to inject link stylesheet with css to be compliant with content security policy
config.autoAddCss = false;

export type FaIconProps = Omit<FontAwesomeIconProps, "icon"> &
  (
    | {
        name: FaIcons;
        icon?: never;
      }
    | {
        name?: never;
        icon: IconDefinition;
      }
  );

/**
 * A component for displaying allowed Font Awesome icons.
 *
 * @see [📝 Documentation](TBD)
 * @see 🏷️ {@link FaIconProps}
 *
 * @example
 * ```jsx
 * <FaIcon width={24} height={22} name={FaIcons.ArrowRight} />
 * ```
 */
const FaIcon: FC<FaIconProps> = ({
  size = "1x",
  width = 24,
  height = 24,
  icon,
  name,
  ...rest
}: FaIconProps) => {
  if (icon == null) icon = toIconProp(name);
  return icon == null ? null : (
    <FontAwesomeIcon
      icon={icon as IconProp}
      size={size}
      height={height}
      width={width}
      {...rest}
    />
  );
};

export { FaIcon };
